import {Pipe, PipeTransform} from '@angular/core';
import {SubtitlesService} from "../core";
import {UnderfloorMode} from "../models";

@Pipe({
    name: 'underfloorMode'
})
export class UnderfloorModePipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    transform(mode: UnderfloorMode): string {
        let modeSubtitle = '';

        if (mode === 'off') {
            modeSubtitle = this.subtitles.setSubtitle(924);
        } else if (mode === 'floorProtection') {
            modeSubtitle = this.subtitles.setSubtitle(3603);
        } else if (mode === 'sustain') {
            modeSubtitle = this.subtitles.setSubtitle(5224);
        }
        return modeSubtitle;
    }
}
